import React, { useEffect, useState, useRef } from "react";
import { Dimensions, Image, Text, TouchableOpacity, View, Linking, } from "react-native";
import Header from "../../common/Header";
import * as RootNavigation from "../../utilities/RootNavigation"
import CImage from "../../common/CImage";
import CustomButton from "../../common/CustomButton";
import applicationStyles from "../../styles/applicationStyles";
import LoginTabIcons from "./LoginTabIcons";
import LoginRightWidget from "./LoginRightWidget";
import LoginMoibleContent from "./LoginMobileContent";
import LoginFooter from "./LoginFooter";
import useStyles from "./SelectForgotScreen_Styles";
import CView from "../../styles/CommonStyle";
import { COLORS } from "../../constant";
const isSmallDevice = Dimensions.get('window').width < 767

export default function SelectForgotScreen(props) {
  const styles = useStyles();
  const [value, setValue] = useState("1");

  const renderSelectForgotSccreen  = () =>{
    return <View style={styles.containerBox}>
    <View
      style={styles.rectangle41}>
      <TouchableOpacity onPress={() => RootNavigation.navigate("Login")}>
        <CImage.BackIconWhite></CImage.BackIconWhite>
      </TouchableOpacity>
      <Text style={[applicationStyles.loginTextStyle]}>{"Forgot User ID/Password"}</Text>
    </View>
    <View style={{ alignItems: "center", marginTop: isSmallDevice ? 0 : "5%" }}>
      <Text style={styles.chooseOptionStyle}>
        {"Choose an option"}
      </Text>
      <CView  MT={'15%'} JC >
        <View style={styles.selectionContainerStyle}>
          <TouchableOpacity onPress={() => setValue("1")} style={styles.radiobuttonOutSideStyle} >
            {
              value == "1"
                ? <View style={styles.radioButtonInsideStyle} />
                : null
            }
          </TouchableOpacity>
          <Text style={styles.textStyle}>
            {"Forgot User Id"}
          </Text>
        </View>
        <View style={[styles.selectionContainerStyle, { marginTop: 20 }]}>
          <TouchableOpacity onPress={() => setValue("2")} style={styles.radiobuttonOutSideStyle} >
            {
              value == "2"
                ? <View style={styles.radioButtonInsideStyle} />
                : null
            }

          </TouchableOpacity>
          <Text style={styles.textStyle}>
            {"Forgot Password"}
          </Text>
        </View>
      </CView>
    </View>
    <CView
     ASC
     MT={30}
     width={108}
     height={37}>
      <CustomButton
        onPress={() => value == "1" ? RootNavigation.navigate("ForgotUserScreen") : RootNavigation.navigate("ForgotPasswordScreen")}
        text={"Proceed"}
      />
    </CView>

  </View>
  }


  return (
    <CView W100 HW>
    <CView flex={1}>
        <Header text={"Login"} />

        <View style={styles.bodyContainerStyle}>
        <CView  BG={COLORS.grayOP69} flex={0.4} AC JC >
            {renderSelectForgotSccreen()}
            
            <LoginTabIcons />
          </CView>
          
          <LoginRightWidget />
        </View>
        <View style={styles.mobileComponentStyle}>
          <View style={styles.logoWidget}>
          <CView FR>
              <CImage.IDFCLogo></CImage.IDFCLogo>
            </CView>
            <View>
              <CImage.FFLogoSmall></CImage.FFLogoSmall>
            </View>
          </View>
          <View style={styles.renderCenter}>
            {renderSelectForgotSccreen()}
          </View>
         
          <LoginMoibleContent />
        </View>

        <LoginFooter />
        </CView>
    </CView>
  );
}



